import Vue from "vue";
import BillInfoComponent from "./component/BillInfo.vue";
import GoodsAddComponent from "./component/GoodsAdd.vue";

const BillInfo = Vue.extend(BillInfoComponent);
const GoodsAdd = Vue.extend(GoodsAddComponent);

//订单详情
const BillInfoModal = options => {
  if (Vue.prototype.$isServer) return;

  const {
    //autoClose,
    ...rest
  } = options;
  const instance = new BillInfo({
    propsData: {
      ...rest
    },
    data: {}
  });
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;

  instance.vm.$on("update", param => {
    if (instance.update) {
      instance.update(param);
    }
  });
  instance.vm.$on("destroy", () => {
    document.body.removeChild(instance.vm.$el);
  });
  return instance.vm;
};
//添加物品
const GoodsAddModal = options => {
  if (Vue.prototype.$isServer) return;

  const {
    //autoClose,
    ...rest
  } = options;
  const instance = new GoodsAdd({
    propsData: {
      ...rest
    },
    data: {}
  });
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;

  instance.vm.$on("update", param => {
    if (instance.update) {
      instance.update(param);
    }
  });
  instance.vm.$on("destroy", () => {
    document.body.removeChild(instance.vm.$el);
  });
  return instance.vm;
};
export { BillInfoModal, GoodsAddModal };
